<template>
  <div class="percentage-bars">
    <h5>Probability for GPC class {{ probabilities.predictions[0][0] }} [{{ probabilities.predictions[0][1] }}]</h5>
    <b-progress
      :value="stripPercentage(probabilities.predictions[0][1])"
      :max="max"
      show-value
      variant="success"
      class="mb-3"
    />

    <h5>Probability for GPC class {{ probabilities.predictions[1][0] }} [{{ probabilities.predictions[1][1] }}]</h5>
    <b-progress
      :value="stripPercentage(probabilities.predictions[1][1])"
      :max="max"
      show-value
      variant="success"
      class="mb-3"
    />

    <h5>Probability for GPC class {{ probabilities.predictions[2][0] }} [{{ probabilities.predictions[2][1] }}]</h5>
    <b-progress
      :value="stripPercentage(probabilities.predictions[2][1]) "
      :max="max"
      show-value
      variant="success"
      class="mb-3"
    />

    <h5>Probability for GPC class {{ probabilities.predictions[3][0] }} [{{ probabilities.predictions[3][1] }}]</h5>
    <b-progress
      :value="stripPercentage(probabilities.predictions[3][1])"
      :max="max"
      variant="success"
      show-value
      class="mb-3"
    />

    <h5>Probability for GPC class {{ probabilities.predictions[4][0] }} [{{ probabilities.predictions[4][1] }}]</h5>
    <b-progress
      :value="stripPercentage(probabilities.predictions[4][1])"
      :max="max"
      variant="success"
      show-value
      class="mb-3"
    />
  </div>
</template>

<script>
export default {
  name: "PercentageBars",
  data() {
    return {
      max: 100
    };
  },
  props: {
    probabilities: {
      type: Object,
      required: true
    }
  },
  methods: {
    stripPercentage(tmp) {
      return parseInt(tmp.slice(0, -1));
    }
  }
};
</script>

<style>
.percentage-bars {
  color: black;
}
</style>
